import { useInjection } from 'inversify-react';

import useCaseGetSimulatorLocations from 'application/modules/bookingWizard/useCases/hooks/useCaseGetSimulatorLocations';
import { InjectableHook } from 'domain/hooks';
import useEffectOnce from 'infrastructure/targets/web/modules/bookingWizard/hooks/useEffectOnce';

export const AppStartupAdapter = Symbol('AppStartupAdapter');

export enum RefreshTokenError {
  Unknown = 'unknown',
}

export interface RefreshTokenResponse {
  refreshToken: string;
}

export type IAppStartupAdapter = InjectableHook<{
  error: Error | null;
  wasSuccesful: boolean;
  handleUpdateAppTitle: () => void;
  initializeFacebookPixel: () => Promise<void>;
  initializeSentry: () => Promise<void>;
  initializeChunkErrorHandler: () => void;
}>;

const useCaseAppStartup = () => {
  const adapter = useInjection<IAppStartupAdapter>(AppStartupAdapter);
  const {
    error,
    wasSuccesful,
    handleUpdateAppTitle,
    initializeFacebookPixel,
    initializeSentry,
    initializeChunkErrorHandler,
  } = adapter();
  const { fetchLocations } = useCaseGetSimulatorLocations();

  useEffectOnce(() => {
    handleUpdateAppTitle();
    initializeFacebookPixel();
    initializeSentry();
    initializeChunkErrorHandler();
    fetchLocations();
  }, []);

  return {
    error,
    result: wasSuccesful,
  };
};

export default useCaseAppStartup;
